/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";

import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";
import { reactSelectStyle } from "Config/Config";

const ticketTypeOptions = [
  { label: "Purchase Ticket", value: "purchase" },
  { label: "Support Ticket", value: "support" },
];

const purchaseStageOptions = [
  { label: "Confirmed", value: "confirmed" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Refunded", value: "refunded" },
];

const supportStageOptions = [
  { label: "Open", value: "open" },
  { label: "In Progress", value: "in_progress" },
  { label: "Resolved", value: "resolved" },
  { label: "Closed", value: "closed" },
];

const priorityOptions = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Urgent", value: "urgent" },
];

const CreateUpdateTicketPopup = ({
  offcanvasId = "createUpdateTicketOffcanvas",
  selectedTicketId = null,
  afterPopupClose = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [errors, setErrors] = useState({});

  const [tickettype, settickettype] = useState(
    ticketTypeOptions[0]
  );

  const [stageValue, setstageValue] = useState(null);
  const [source, setsource] = useState("manual");

  // lead association
  const [leadInput, setleadInput] = useState("");
  const [leadOptions, setleadOptions] = useState([]);
  const [leadValue, setleadValue] = useState(null);
  const [contactName, setcontactName] = useState("");
  const [contactSurname, setcontactSurname] = useState("");
  const [contactEmail, setcontactEmail] = useState("");
  const [contactPhone, setcontactPhone] = useState("");

  // company association
  const [companyInput, setcompanyInput] = useState("");
  const [companyOptions, setcompanyOptions] = useState([]);
  const [companyValue, setcompanyValue] = useState(null);

  // owner (internal account handling this ticket)
  const [ownerInput, setownerInput] = useState("");
  const [ownerOptions, setownerOptions] = useState([]);
  const [ownerValue, setownerValue] = useState(null);

  // purchase-only fields
  const [event, setevent] = useState("");
  const [sessionDate, setsessionDate] = useState("");
  const [seat, setseat] = useState("");
  const [sector, setsector] = useState("");
  const [zone, setzone] = useState("");
  const [entrycode, setentrycode] = useState("");
  const [finalPrice, setfinalPrice] = useState("");
  const [currency, setcurrency] = useState("");
  const [clientPromotion, setclientPromotion] = useState("");

  // support-only fields
  const [subject, setsubject] = useState("");
  const [description, setdescription] = useState("");
  const [priorityValue, setpriorityValue] = useState(priorityOptions[1]);
  const [category, setcategory] = useState("");
  const [duedate, setduedate] = useState("");
  const [resolutionnotes, setresolutionnotes] = useState("");

  // comment thread (edit mode only)
  const [comments, setcomments] = useState([]);
  const [newComment, setnewComment] = useState("");
  const [isAddingComment, setIsAddingComment] = useState(false);

  const isEditMode = Boolean(selectedTicketId);
  const stageOptions =
    tickettype.value === "support" ? supportStageOptions : purchaseStageOptions;

  const getLeadOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_LEAD_OPTIONS}?leadstringinput=${leadInput}`;
      const response = await getData(requestUrl);
      if (response.status) setleadOptions(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCompanyOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_COMPANY_BY_SEARCH}?filtername=${companyInput}`;
      const response = await getData(requestUrl);
      if (response.status) setcompanyOptions(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getOwnerOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_USERLIST_OPTIONS}?userstringinput=${ownerInput}`;
      const response = await getData(requestUrl);
      if (response.status) setownerOptions(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (leadInput.length > 1) getLeadOptions();
  }, [leadInput]);

  useEffect(() => {
    if (companyInput.length > 1) getCompanyOptions();
  }, [companyInput]);

  useEffect(() => {
    if (ownerInput.length > 1) getOwnerOptions();
  }, [ownerInput]);

  const leadSelectionHandler = (val) => {
    setleadValue(val);
    if (!val) {
      setleadInput("");
      setleadOptions([]);
    }
  };

  const companySelectionHandler = (val) => {
    setcompanyValue(val);
    if (!val) {
      setcompanyInput("");
      setcompanyOptions([]);
    }
  };

  const ownerSelectionHandler = (val) => {
    setownerValue(val);
    if (!val) {
      setownerInput("");
      setownerOptions([]);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!leadValue && !contactEmail.trim()) {
      newErrors.contact = "Select an existing lead or enter contact email";
    }

    if (tickettype.value === "support" && !subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    if (tickettype.value === "purchase" && !event.trim()) {
      newErrors.event = "Event / show name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetHandler = () => {
    setErrors({});
    settickettype(ticketTypeOptions[0]);
    setstageValue(null);
    setsource("manual");

    setleadInput("");
    setleadOptions([]);
    setleadValue(null);
    setcontactName("");
    setcontactSurname("");
    setcontactEmail("");
    setcontactPhone("");

    setcompanyInput("");
    setcompanyOptions([]);
    setcompanyValue(null);

    setownerInput("");
    setownerOptions([]);
    setownerValue(null);

    setevent("");
    setsessionDate("");
    setseat("");
    setsector("");
    setzone("");
    setentrycode("");
    setfinalPrice("");
    setcurrency("");
    setclientPromotion("");

    setsubject("");
    setdescription("");
    setpriorityValue(priorityOptions[1]);
    setcategory("");
    setduedate("");
    setresolutionnotes("");

    setcomments([]);
    setnewComment("");
  };

  const populateFormFromTicket = (ticket) => {
    const typeOpt =
      ticketTypeOptions.find((opt) => opt.value === ticket.tickettype) ||
      ticketTypeOptions[0];
    settickettype(typeOpt);

    const stageOpts =
      ticket.tickettype === "support" ? supportStageOptions : purchaseStageOptions;
    setstageValue(
      stageOpts.find((opt) => opt.value === ticket.stage) || null
    );

    setsource(ticket.source || "manual");

    if (ticket.lead) {
      setleadValue({
        label: `${ticket.lead.name || ""} ${ticket.lead.surname || ""}`.trim() || ticket.lead.email,
        value: ticket.lead._id,
      });
    }

    if (ticket.company) {
      setcompanyValue({ label: ticket.company.name, value: ticket.company._id });
    }

    if (ticket.owner) {
      setownerValue({
        label: `${ticket.owner.name || ""} ${ticket.owner.surname || ""}`.trim() || ticket.owner.email,
        value: ticket.owner._id,
      });
    }

    setevent(ticket.event || "");
    setsessionDate(ticket.session_date || "");
    setseat(ticket.seat || "");
    setsector(ticket.sector || "");
    setzone(ticket.zone || "");
    setentrycode(ticket.entrycode || "");
    setfinalPrice(ticket.final_price || "");
    setcurrency(ticket.currency || "");
    setclientPromotion(ticket.client_promotion || "");

    setsubject(ticket.subject || "");
    setdescription(ticket.description || "");
    setpriorityValue(
      priorityOptions.find((opt) => opt.value === ticket.priority) ||
        priorityOptions[1]
    );
    setcategory(ticket.category || "");
    setduedate(ticket.duedate || "");
    setresolutionnotes(ticket.resolutionnotes || "");

    setcomments(ticket.comments || []);
  };

  const getTicketDetails = async () => {
    try {
      setIsLoadingDetails(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_TICKET_DETAILS}/${selectedTicketId}`;
      const response = await getData(requestUrl);
      if (response.status) {
        populateFormFromTicket(response.data);
      }
      setIsLoadingDetails(false);
    } catch (error) {
      setIsLoadingDetails(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (selectedTicketId) {
      getTicketDetails();
    } else {
      resetHandler();
      setownerValue(
        userInfo
          ? {
              label: `${userInfo.name || ""} ${userInfo.surname || ""}`.trim() ||
                userInfo.email,
              value: userInfo._id,
            }
          : null
      );
    }
  }, [selectedTicketId]);

  const closeOffcanvas = () => {
    let offCanvasPopup = document.querySelector(`#${offcanvasId}`);
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    if (offCanvas) offCanvas.hide();
  };

  const saveTicket = async () => {
    if (!validateForm()) return;

    setIsSaving(true);

    let ticketData = {
      tickettype: tickettype.value,
      stage: stageValue ? stageValue.value : "",
      source,
      company: companyValue ? companyValue.value : null,
      owner: ownerValue ? ownerValue.value : null,
    };

    if (leadValue) {
      ticketData.lead = leadValue.value;
    } else {
      ticketData.name = contactName;
      ticketData.surname = contactSurname;
      ticketData.email_client = contactEmail;
      ticketData.phone_client = contactPhone;
    }

    if (tickettype.value === "purchase") {
      ticketData.event = event;
      ticketData.session_date = sessionDate;
      ticketData.seat = seat;
      ticketData.sector = sector;
      ticketData.zone = zone;
      ticketData.entrycode = entrycode;
      ticketData.final_price = finalPrice;
      ticketData.currency = currency;
      ticketData.client_promotion = clientPromotion;
    } else {
      ticketData.subject = subject;
      ticketData.description = description;
      ticketData.priority = priorityValue ? priorityValue.value : "medium";
      ticketData.category = category;
      ticketData.duedate = duedate;
      ticketData.resolutionnotes = resolutionnotes;
    }

    try {
      let response;
      if (isEditMode) {
        let requestUrl = `${url.API_BASE_URL}${url.API_UPDATE_TICKET}/${selectedTicketId}`;
        response = await putData(requestUrl, ticketData);
      } else {
        let requestUrl = `${url.API_BASE_URL}${url.API_CREATE_TICKET}`;
        response = await postData(requestUrl, ticketData);
      }

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        closeOffcanvas();
        resetHandler();
        afterPopupClose([response.data]);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setIsSaving(false);
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const addCommentHandler = async () => {
    if (!newComment.trim() || !selectedTicketId) return;

    try {
      setIsAddingComment(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_ADD_TICKET_COMMENT}/${selectedTicketId}`;
      const response = await putData(requestUrl, { message: newComment });
      setIsAddingComment(false);
      if (response.status) {
        setcomments(response.data.comments || []);
        setnewComment("");
      }
    } catch (error) {
      setIsAddingComment(false);
      console.log(error.message);
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end bg-white border-0"
      tabIndex="-1"
      id={offcanvasId}
      aria-labelledby="createUpdateTicketLabel"
      style={{ width: "500px" }}
    >
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div>
          <h3
            className="offcanvas-title fw-bold text-white mb-0"
            id="createUpdateTicketLabel"
          >
            {isEditMode ? "Update Ticket" : "Create Ticket"}
          </h3>
          <p className="text-white fs-sm mb-0">
            {tickettype.value === "purchase"
              ? "Ticket purchase details"
              : "Support / helpdesk ticket"}
          </p>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      <div className="offcanvas-body p-4">
        {isLoadingDetails ? (
          <div className="placeholder-glow d-flex flex-column gap-3">
            <span className="placeholder placeholder-lg bg-secondary col-12"></span>
            <span className="placeholder placeholder-lg bg-secondary col-8"></span>
          </div>
        ) : (
          <form onSubmit={(e) => e.preventDefault()}>
            {/* ticket type, locked once created */}
            <div className="form-group mb-4">
              <label className="d-block fs-sm fw-semibold mb-2">
                Ticket Type
              </label>
              <Select
                isDisabled={isEditMode}
                styles={reactSelectStyle("3px", "6px", true, true)}
                options={ticketTypeOptions}
                value={tickettype}
                onChange={(val) => val && settickettype(val)}
              />
            </div>

            {/* lead / contact association */}
            <div className="form-group mb-4">
              <label className="d-block fs-sm fw-semibold mb-2">
                Lead (buyer / requester)
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, true)}
                placeholder="Search lead by name or email"
                options={leadOptions}
                value={leadValue}
                onChange={leadSelectionHandler}
                onInputChange={(val) => setleadInput(val)}
              />
              {errors.contact && (
                <div className="text-danger fs-xs mt-1">{errors.contact}</div>
              )}
            </div>

            {!leadValue && (
              <div className="p-3 mb-4 border rounded-8 bg-light">
                <p className="fs-sm fw-semibold mb-2">
                  Or create a new lead for this ticket
                </p>
                <div className="row g-2">
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control fs-sm"
                      placeholder="First name"
                      value={contactName}
                      onChange={(e) => setcontactName(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control fs-sm"
                      placeholder="Last name"
                      value={contactSurname}
                      onChange={(e) => setcontactSurname(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="email"
                      className="form-control fs-sm"
                      placeholder="Email"
                      value={contactEmail}
                      onChange={(e) => setcontactEmail(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control fs-sm"
                      placeholder="Phone"
                      value={contactPhone}
                      onChange={(e) => setcontactPhone(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* company association */}
            <div className="form-group mb-4">
              <label className="d-block fs-sm fw-semibold mb-2">
                Company / Theatre
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, true)}
                placeholder="Search company name"
                options={companyOptions}
                value={companyValue}
                onChange={companySelectionHandler}
                onInputChange={(val) => setcompanyInput(val)}
              />
            </div>

            {/* owner association */}
            <div className="form-group mb-4">
              <label className="d-block fs-sm fw-semibold mb-2">
                Owner (handled by)
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, true)}
                placeholder="Search team member"
                options={ownerOptions}
                value={ownerValue}
                onChange={ownerSelectionHandler}
                onInputChange={(val) => setownerInput(val)}
              />
            </div>

            {/* stage + source */}
            <div className="row g-2 mb-4">
              <div className="col-6">
                <label className="d-block fs-sm fw-semibold mb-2">Stage</label>
                <Select
                  isClearable
                  styles={reactSelectStyle("3px", "6px", true, true)}
                  options={stageOptions}
                  value={stageValue}
                  onChange={(val) => setstageValue(val)}
                />
              </div>
              <div className="col-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  Source
                </label>
                <input
                  type="text"
                  className="form-control fs-sm"
                  placeholder="manual / onebox / clorian"
                  value={source}
                  onChange={(e) => setsource(e.target.value)}
                />
              </div>
            </div>

            {tickettype.value === "purchase" ? (
              <>
                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Event / Show
                  </label>
                  <input
                    type="text"
                    className={`form-control fs-sm ${
                      errors.event ? "is-invalid" : ""
                    }`}
                    placeholder="e.g., The Lion King"
                    value={event}
                    onChange={(e) => setevent(e.target.value)}
                  />
                  {errors.event && (
                    <div className="invalid-feedback">{errors.event}</div>
                  )}
                </div>

                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Session Date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control fs-sm"
                    value={sessionDate}
                    onChange={(e) => setsessionDate(e.target.value)}
                  />
                </div>

                <div className="row g-2 mb-4">
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Seat
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      value={seat}
                      onChange={(e) => setseat(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Sector
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      value={sector}
                      onChange={(e) => setsector(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Zone
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      value={zone}
                      onChange={(e) => setzone(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Entry Code
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      value={entrycode}
                      onChange={(e) => setentrycode(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row g-2 mb-4">
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Price
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      value={finalPrice}
                      onChange={(e) => setfinalPrice(e.target.value)}
                    />
                  </div>
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Currency
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      placeholder="EUR"
                      value={currency}
                      onChange={(e) => setcurrency(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Offer / Promotion applied
                  </label>
                  <input
                    type="text"
                    className="form-control fs-sm"
                    value={clientPromotion}
                    onChange={(e) => setclientPromotion(e.target.value)}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    className={`form-control fs-sm ${
                      errors.subject ? "is-invalid" : ""
                    }`}
                    placeholder="Brief summary of the request"
                    value={subject}
                    onChange={(e) => setsubject(e.target.value)}
                  />
                  {errors.subject && (
                    <div className="invalid-feedback">{errors.subject}</div>
                  )}
                </div>

                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Description
                  </label>
                  <textarea
                    rows="4"
                    className="form-control fs-sm"
                    value={description}
                    onChange={(e) => setdescription(e.target.value)}
                  ></textarea>
                </div>

                <div className="row g-2 mb-4">
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Priority
                    </label>
                    <Select
                      styles={reactSelectStyle("3px", "6px", true, true)}
                      options={priorityOptions}
                      value={priorityValue}
                      onChange={(val) => setpriorityValue(val)}
                    />
                  </div>
                  <div className="col-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Category
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm"
                      value={category}
                      onChange={(e) => setcategory(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Due Date
                  </label>
                  <input
                    type="date"
                    className="form-control fs-sm"
                    value={duedate}
                    onChange={(e) => setduedate(e.target.value)}
                  />
                </div>

                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Resolution Notes
                  </label>
                  <textarea
                    rows="3"
                    className="form-control fs-sm"
                    value={resolutionnotes}
                    onChange={(e) => setresolutionnotes(e.target.value)}
                  ></textarea>
                </div>

                {isEditMode && (
                  <div className="form-group mb-4">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      Comments
                    </label>
                    <div className="d-flex flex-column gap-2 mb-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {comments.length === 0 && (
                        <p className="fs-xs text-muted mb-0">No comments yet</p>
                      )}
                      {comments.map((item, index) => (
                        <div
                          key={index}
                          className="p-2 border rounded-8 bg-light fs-xs"
                        >
                          {item.message}
                        </div>
                      ))}
                    </div>
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        className="form-control fs-sm"
                        placeholder="Add a comment"
                        value={newComment}
                        onChange={(e) => setnewComment(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        disabled={isAddingComment}
                        onClick={addCommentHandler}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}

            <button
              type="button"
              className="btn btn-primary w-100 mt-2"
              disabled={isSaving}
              onClick={saveTicket}
            >
              {isSaving ? "Saving..." : isEditMode ? "Update Ticket" : "Create Ticket"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default CreateUpdateTicketPopup;
